<template>
  <div class="wg-rating" v-if="rating">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text wg-bonuses__title">
            Рейтинг
          </v-card-title>
          <v-card-text v-if="loading">
            <p>Список рейтингов загружается...</p>
          </v-card-text>
          <v-card-text v-else class="wg-rating__card-text pt-3">
            <div class="h-table h-table--w12 wg-rating__table">
              <div class="h-table__thead">
                <div class="h-table__tr">
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--place">Место в&nbsp;рейтинге</div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--company">Компания-партнер</div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--name">ФИО</div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--bonus">Бонусы</div>
                </div>
              </div>
              <div class="h-table__tbody">
                <div
                  class="h-table__tr wg-rating__table-tr"
                  :class="{current: user.profile_id === r.profile_id}"
                  v-for="(r, idx) in rating"
                  :key="rating.id"
                >
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--place wg-rating__table-td--first">
                    <div class="wg-rating__table-td-header">Место&nbsp;в&nbsp;рейтинге:</div>
                    <div class="wg-rating__table-td-content">{{idx + 1}}</div>
                  </div>

                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--company">
                    <div class="wg-rating__table-td-header">Проектная организация:</div>
                    <div class="wg-rating__table-td-content">{{r.dealer_name}}</div>

                  </div>
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--name">
                    <div class="wg-rating__table-td-header">ФИО:</div>
                    <div class="wg-rating__table-td-content">{{r.fio}}</div>
                  </div>
                  <div  class="h-table__td wg-rating__table-td wg-rating__table-td--bonus">
                    <div class="wg-rating__table-td-header">Бонусы:</div>
                    <div class="wg-rating__table-td-content">{{r.bonuses}}</div>
                  </div>

                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: ['rating', 'loading'],
    computed: {
      user() {
        return this.$store.state.user;
      },

    },
    methods: {
      /**
       * Изменение заголовка для таблицы
       * @param {string} label - заголовок бонусного этапа
       */
      ChangeLabel(label) {
        const labelArray = label.split(' ');
        const headerLabel = `${labelArray[0]}<br>${labelArray[1]}&nbsp;${labelArray[2]}`;
        const tdLabel = `${labelArray[0]}&nbsp;${labelArray[1]}&nbsp;${labelArray[2]}`;
        return { headerLabel, tdLabel };
      },
    },
  };
</script>

<style lang="scss">
  @import "src/assets/scss/variables";

  .wg-rating {
    &__card-text {
      @media (min-width: 1200px) {
        overflow-x: auto;
      }
    }

    &__table-tr {
      @media (max-width: 1200px) {
        border: 1px solid $wg-rating-table-border-color;
        padding: 6px;
        margin-bottom: 30px;
      }

      &.current {
        .wg-rating__table-td {
          &--name {
            background-color: $wg-rating-table-current-accent-td-bg-color;
          }

          &.current {
            background-color: $wg-rating-table-current-accent-td-bg-color;
          }
        }

        @media (max-width: 1200px) {
          background-color: $wg-rating-table-current-td-bg-color;
        }
        @media (min-width: 1200px) {
          .wg-rating__table-td {
            background-color: $wg-rating-table-current-td-bg-color;

            &--name {
              background-color: $wg-rating-table-current-accent-td-bg-color;
            }
          }
        }
      }
    }

    &__table-tr {
      @media (max-width: 1201px) {
        margin-bottom: 0;
      }
    }

    &__table-th {
      border-right: 1px solid $wg-rating-table-border-color;
      color: $wg-rating-table-header-color;
      font-size: 14px;
      padding: 4px;

      @media (max-width: 1201px) {
        display: none!important;
      }

      &:last-child {
        border-right: none;
      }

      &.current {
        background-color: $wg-rating-table-current-td-bg-color;
      }
    }

    &__table-td {
      border-top: 1px solid $wg-rating-table-border-color;
      border-right: 1px solid $wg-rating-table-border-color;
      padding: 4px;
      font-size: 12px;

      @media (max-width: 1200px) {
        display: flex;
        justify-content: space-between;
        border-right: none;
        border-top: 1px dotted $wg-rating-table-border-color;
      }

      &:last-child {
        border-right: none;
      }

      &--first {
        @media (max-width: 1200px) {
          border-top: none;
        }
      }

      &.current {
        background-color: $wg-rating-table-current-td-bg-color;
      }
    }

    &__table-td-header {
      padding-right: 4px;
      color: $wg-rating-table-header-color;

      @media (min-width: 1200px) {
        display: none;
      }
    }

    &__table-td-content {
      font-weight: bold;
    }
  }
</style>
